<template>
  <b-form
    ref="uploadForm"
    class="mt-5"
    @submit.prevent="onSubmit"
  >
    <b-row class="justify-content-center">
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group
          label="コミュニティ名"
          label-for="title"
        >
          <b-form-input
            id="title"
            :value="title"
            name="title"
            type="text"
            required
            placeholder="コミュニティ名を記入してください"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group
          label="コミュニティ詳細"
          label-for="description"
        >
          <b-form-textarea
            id="description"
            :value="description"
            name="description"
            rows="6"
            required
            placeholder="コミュニティ詳細を記入してください"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group
          label="画像をアップロードしてください"
          label-for="name"
        >
          <cropper
            ref="cropper"
            class="cropper"
            :src="media"
            :stencil-props="{aspectRatio: 16/6}"
            @ready="cropperReady"
          />
          <b-button
            block
            variant="success"
            class="upload-btn"
          >
            <b-form-file
              ref="file"
              name="media"
              @change="loadImage($event)"
            />
            画像をアップロードしてください
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="justify-content-center">
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group
          label="コミュニティの目的"
          label-for="type"
        >
          <b-form-select
            :value="type"
            name="type"
            :options="typeOptions"
            required
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="justify-content-center mt-3">
      <b-col
        cols="12"
        sm="6"
      >
        <b-form-group>
          <b-button
            type="submit"
            block
            variant="primary"
            size="lg"
            :disabled="communityStatus === 'loading'"
          >
            <b-icon
              v-if="communityStatus === 'loading'"
              icon="three-dots"
              animation="cylon"
              font-scale="1"
            />
            <span v-else>コミュニティを保存</span>
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import { mapGetters } from "vuex";
import {COMMUNITY_TYPE_REQUEST, TAG_REQUEST} from "@/store/constant";

export default {
  name: "Form",
  components: { Cropper },
  props: {
    title: String,
    description: String,
    media: String,
    type: String,
  },
  computed: {
    ...mapGetters(['communityTypes', 'communityStatus']),
    typeOptions() {
      let arr = this.communityTypes.map(item => {
        return {value: item.id, text: item.title}
      })
      arr.unshift({ value: '', text: '選択してください' });
      return arr;
    },
  },
  mounted() {
    this.getTypes();
  },
  methods: {
    getTypes() {
      this.$store.dispatch(COMMUNITY_TYPE_REQUEST);
      this.$store.dispatch(TAG_REQUEST);
    },
    onSubmit() {
      const { canvas } = this.$refs.cropper.getResult();
      let formInputData = {};
      for(const item of this.$refs["uploadForm"].elements) {
        formInputData[item.name] = item.value;
      }
      const { title, description, type } = formInputData;
      const data = { title, description, type };

      this.$emit('onSubmit', data, canvas);
    },
    cropperReady() {
      this.$emit('cropperReady');
    },
    loadImage(event) {
      this.$emit('loadImage', event);
    },
  }
}
</script>
